/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgOverageRecord { 
    created_ts?: Date;
    csp_service_type: string;
    current_level?: string;
    level_updated_ts?: Date;
    next_action_date?: Date;
    org_id: string;
    overage_duration?: number;
    overage_started_ts?: Date;
    previous_level?: string;
    updated_ts?: Date;
}

